import React from 'react';
// import styles from './SearchToolbar.module.scss';
// import { Button, TextInput } from '../../UI';
// import { IconSearch, IconCaretLeft, IconCaretRight } from '../../Icon';
// import { postDocumentSearch } from '../../../api/signalSearchApi';

interface SearchToolbarProps {
  documentId: string;
  onNavigate: (payload: { pageId: string; highlightText?: string }) => void;
}

const SearchToolbar: React.FC<SearchToolbarProps> = () => {
  // UX isn't great since semantic search doesn't make clear what is matched on, need to rethink
  return null;
  // const [query, setQuery] = useState('');
  // const [isSearching, setIsSearching] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [results, setResults] = useState<
  //   { embeddingId: string; pageId: string; highlightText?: string }[] | null
  // >(null);
  // const [currentIndex, setCurrentIndex] = useState(0);

  // const runSearch = async () => {
  //   const q = query.trim();
  //   if (!q) return;
  //   setIsSearching(true);
  //   setError(null);
  //   setResults(null);
  //   try {
  //     const resp = await postDocumentSearch({ query: q, documentId });
  //     const hits = resp.results.map((r) => ({
  //       embeddingId: r.embeddingId,
  //       pageId: r.pageId,
  //       highlightText: r.highlightText,
  //     }));
  //     setResults(hits);
  //     setCurrentIndex(0);
  //     if (hits.length > 0) {
  //       onNavigate({ pageId: hits[0].pageId, highlightText: hits[0].highlightText });
  //     }
  //   } catch (_e) {
  //     setError('Search failed');
  //   } finally {
  //     setIsSearching(false);
  //   }
  // };

  // const gotoIndex = (idx: number) => {
  //   if (!results || results.length === 0) return;
  //   const normalized = (idx + results.length) % results.length;
  //   setCurrentIndex(normalized);
  //   onNavigate({
  //     pageId: results[normalized].pageId,
  //     highlightText: results[normalized].highlightText,
  //   });
  // };

  // return (
  //   <div className={styles.toolbar}>
  //     <div className={styles.searchForm}>
  //       <TextInput
  //         value={query}
  //         onChange={setQuery}
  //         placeholder="Search in document"
  //         onKeyDown={(e) => {
  //           if (e.key === 'Enter') {
  //             e.preventDefault();
  //             if (!isSearching) {
  //               runSearch();
  //             }
  //           }
  //         }}
  //       />
  //       <Button
  //         variant="primary"
  //         onClick={runSearch}
  //         disabled={isSearching}
  //         icon={<IconSearch size={16} />}
  //         aria-label="Search"
  //       />
  //     </div>
  //     <div className={styles.resultsInfo}>
  //       {isSearching ? (
  //         <span>Searching…</span>
  //       ) : error ? (
  //         <span className={styles.errorText}>{error}</span>
  //       ) : results === null ? null : results.length > 0 ? (
  //         <>
  //           <span>
  //             {currentIndex + 1} of {results.length}
  //           </span>
  //           <Button
  //             variant="secondary"
  //             size="small"
  //             onClick={() => gotoIndex(currentIndex - 1)}
  //             icon={<IconCaretLeft size={16} />}
  //             aria-label="Previous result"
  //           />
  //           <Button
  //             variant="secondary"
  //             size="small"
  //             onClick={() => gotoIndex(currentIndex + 1)}
  //             icon={<IconCaretRight size={16} />}
  //             aria-label="Next result"
  //           />
  //         </>
  //       ) : (
  //         <span>No results</span>
  //       )}
  //     </div>
  //   </div>
  // );
};

export default SearchToolbar;
